DealTrackContentLoaded = window.DealTrackContentLoaded = (startTimestamp) ->

  dealContentLoaded = +new Date()
  track(startTimestamp, dealContentLoaded)

track = (startTimestamp, endTimestamp) ->
  if (typeof BOOMR != 'undefined') and (typeof BOOMR.addVar == 'function')
    BOOMR.addVar('t_deal_content_loaded', endTimestamp - startTimestamp)

module.exports = DealTrackContentLoaded



// WEBPACK FOOTER //
// ./modules/deal/frontend/deal_track_content_loaded.coffee